<template>
  <div
    id="form_bar"
    :style="{
      'border-left': shrink ? '' : '1px solid #3e3e3e',
    }"
  >
    <div class="option">
      <div class="label">{{ $t("company.FORM_NAME") }}</div>
      <input type="text" v-model="nameInput" />

    </div>
    <div class="option">
      <div class="label">{{ $t("company.FORM_COMPANY") }}</div>
      <input type="text" v-model="companyInput" />

    </div>
    <div class="option">
      <div class="label">{{ $t("company.FORM_PHONE") }}</div>
      <input type="text" v-model="phoneInput" />

    </div>
    <div class="option">
      <div class="label">{{ $t("company.FORM_EMAIL") }}</div>
      <input type="text" v-model="emailInput" />
    </div>
    <div class="option">
      <div class="label">{{ $t("company.FORM_ADDRESS") }}</div>
      <input
        type="text"
        v-model="addressInput"
        @blur="onBlur"
        @input.capture="onChang"
        @focus="onFocus"
      />
      <div class="tipBar" v-show="visible">
        <div
          class="bar"
          v-for="(tip, index) in matchWords"
          :key="index"
          @click="onSelect(tip)"
        >
          {{ tip }}
        </div>
      </div>
    </div>
    <div class="option">
      <div class="label">{{ $t("company.FORM_MESSAGE") }}</div>
      <textarea v-model="messageInput"></textarea>
    </div>
    <div class="footer_area">
      <div class="button" @click="onSend">
        <van-loading v-if="loading" size="20" color="#fff" />
        <span v-else>{{ $t("company.BUTTON") }}</span>
      </div>
    </div>
  </div>
</template>

<script setup lang="ts">
import provide_key from "@/constant/provide_key";
import { inject, nextTick, ref } from "vue";
import axios from "axios";
import emailConstant from "@/constant/email_constant";
import zhCountry from "@/utils/languages/zh/json/country.json";
import enCountry from "@/utils/languages/en/json/country.json";
import { useI18n } from "vue-i18n";
import { showToast } from "vant";
const { t, locale } = useI18n();

const shrink: boolean | undefined = inject(provide_key.SHRINK);
const visible = ref<boolean>(false);
let timer: any;
const nameInput = ref<string>("");
const companyInput = ref<string>("");
const phoneInput = ref<string>("");
const emailInput = ref<string>("");
const addressInput = ref<string>("");
const messageInput = ref<string>("");
const matchWords = ref<string[]>([]);

const verifyEmpty = () => {
  const forms = [
    nameInput.value,
    companyInput.value,
    phoneInput.value,
    emailInput.value,
    addressInput.value,
    messageInput.value,
  ]
  const pass = forms.every(form => form.trim() !== "")
  if(!pass) showToast(t("company.EMPTY_TOAST"))
  return pass
};

const onSelect = (tip: string) => {
  addressInput.value = tip;
};

const onFocus = () => {
    const countrys =
      locale.value === "zh"
        ? Object.values(zhCountry)
        : Object.values(enCountry);
    matchWords.value = countrys
    visible.value = true
}

const onChang = () => {
  clearTimeout(timer);
  timer = setTimeout(() => {
    if (addressInput.value === "") return;
    const countrys =
      locale.value === "zh"
        ? Object.values(zhCountry)
        : Object.values(enCountry);
    matchWords.value = matchWord(addressInput.value, countrys);
    visible.value = true;
  }, 500);
};

const onBlur = () => {
    setTimeout(() => {
        visible.value = false
    }, 100)
}

const requestToSendEmail = (data: any) => {
  loading.value = true;
  axios({
    method: "post",
    url: "https://api.emailjs.com/api/v1.0/email/send",
    data,
  })
    .then((res) => {
      showToast(t("company.SUCCESS_TOAST"));
      loading.value = false;
    })
    .catch((res) => {
      showToast(t("company.ERROR_TOAST"));
      loading.value = false;
    });
};

const onSend = () => {
  if (loading.value || !verifyEmpty()) return;
  const option = {
    service_id: emailConstant.SERVICE_ID,
    template_id: emailConstant.TEMPLATE_ID,
    user_id: emailConstant.PUBLIC_KEY,
    template_params: {
      name: nameInput.value,
      company: companyInput.value,
      phone: phoneInput.value,
      email: emailInput.value,
      address: addressInput.value,
      message: messageInput.value,
    },
  };
  requestToSendEmail(option);
};

const loading = ref<boolean>(false);

const matchWord = (input: string, words: string[]) => {
  const regex = new RegExp(input, "i"); // 'i' flag for case-insensitive matching
  return words.filter((word) => regex.test(word));
};
</script>

<style lang="less" scoped>
#form_bar {
  flex: 1;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  gap: 1rem;
  width: 100%;
  overflow-y: hidden;

  .option {
    width: 80%;
    display: flex;
    flex-direction: column;
    align-items: baseline;
    position: relative;
    overflow: visible;
  }

  .label {
    font-size: var(--label-description);
    font-weight: normal;
    color: var(--font-color-black-light);
  }

  .footer_area {
    width: 80%;
    display: flex;
    justify-content: flex-end;
    margin-top: 1rem;

    .button {
      border-radius: 1rem;
      background: #002fa5;
      display: flex;
      padding: 0.5rem 2rem;
      align-items: center;
      color: var(--font-color-white-strong);

      &:hover {
        background: #073dc4;
        cursor: pointer;
      }
    }
  }

  input[type="text"] {
    width: 100%;
    height: 100%;
    background: transparent;
    outline: none;
    border: none;
    color: var(--font-color-black);
    font-weight: 400;
    font-size: 12px;
    background: var(--bg-color-white-gray);
    padding: 8px 10px;
    border-radius: 2px;

    &::placeholder {
      color: var(--font-color-white-strong);
    }

    &:focus {
      background: #a3a3a3;
    }
  }

  .icon {
    position: absolute;
    top: 2.2rem;
    right: 0.5rem;
  }

  .tipBar {
    width: 100%;
    display: flex;
    flex-direction: column;
    position: absolute;
    left: 0;
    top: 4rem;
    width: 100%;
    z-index: 2;
    max-height: 10rem;
    overflow-y: auto;

    .bar {
      padding: 2px 10px;
      border-bottom: 1px solid #666;
      flex-shrink: 0;
      cursor: pointer;
      font-size: 12px;
      background: #a3a3a3;
      color: var(--font-color-white-strong);

      &:last-child {
        border: none;
      }

      &:hover {
        background: #30467c;
      }
    }
  }

  textarea {
    width: 100%;
    height: 100%;
    padding-right: 10px;
    background: transparent;
    outline: none;
    border: none;
    color: var(--font-color-black);
    font-weight: 400;
    font-size: 12px;
    background: var(--bg-color-white-gray);
    padding: 8px 10px;
    border-radius: 2px;
    resize: none;

    &::placeholder {
      color: var(--font-color-white-strong);
    }

    &:focus {
      background: #a3a3a3;
    }
  }
}
</style>